import { swup } from '../main'

const customFormFields = (() => {
	const cff = {
		selects: [],
		radios: [],
		realQtyPicker: undefined,
		fakeQtyPicker: undefined,
	};

	const step = 1;

	cff.getProductInfo = () => {
		let productId = undefined;
		const variationForm = document.querySelector('.variations_form');
		let attributes = null;
		let attributesStr = '';

		if(variationForm) {
			// Is variable product
			productId = variationForm.getAttribute('data-product_id');
			cff.selects.forEach((select) => {
				const name = select.getAttribute('data-attribute_name');

				attributesStr += `${name}|${select.value},`
			})


			var pos = attributesStr.lastIndexOf(',');
			attributesStr = attributesStr.substring(0, pos) + attributesStr.substring(pos + 1)

			attributes = { attributes: attributesStr };
		} else {
			// Is simple product
			const addToCart = document.querySelector('.add-to-cart');
			if(addToCart)
			{
				productId = addToCart.getAttribute('data-id');
			}
		}

		const quantity = (cff.fakeQtyPicker && cff.fakeQtyPicker.value)
			? Number(cff.fakeQtyPicker.value)
			: 0;

		return {
			productId,
			attributes,
			quantity,
		};
	}


	cff.createProductLink = (e) => {
		if (!e.target.classList.contains('notification-button')) {
			return;
		}

		e.preventDefault();

		let productInfo = cff.getProductInfo();
		if(!productInfo)
		{
			return;
		}

		const baseUrl = e.target.getAttribute('data-url');

		let params = {
			product_id: productInfo.productId,
			quantity: productInfo.quantity,
		}

		if(productInfo.attributes)
		{
			params = {
				...params,
				...productInfo.attributes,
			}
		}

		const newParams = new URLSearchParams([
			...Object.entries(params),
		]).toString();

		const newUrl = `${baseUrl}?${newParams}`;

		swup.loadPage({
			url: newUrl,
		});
	}

	cff.getAvailableValues = () => {
		if(!cff.selects.length) {
			return;
		}

		let availableValues = [];

		cff.selects.forEach((select) => {
			const $select = $(select);
			const $id = select.id;

			const $options = $select.find('option');

			let optionValues = Array.from($options).map((option, i) => {
				return option.value ? option.value : null;
			});

			optionValues = optionValues.filter((value) => {
				return value !== null;
			})

			availableValues.push({
				name : $id,
				options : optionValues,
			});
		})

		return availableValues;
	}

	cff.toggleRadios = function() {
		setTimeout(() => {
			let availableValues = cff.getAvailableValues();

			cff.radios.forEach((group) => {

				const $radios = $(group).find('input');
				const $groupID = $(group).attr('data-select');

				const getValues = availableValues.filter((valueGroup) => {
					return valueGroup.name === $groupID;
				})

				if(!getValues.length) {
					return;
				}

				const availableOptions = getValues[0].options;

				$radios.each((i, radio) => {
					if(!availableOptions.includes(radio.value))
					{
						$(radio).attr('disabled', true);
					} else {
						$(radio).removeAttr('disabled');
					}
				})
			})
		}, 50 );
	}

	cff.initCustomUI = function() {
		const $customiser = $('.customiser');
		const $radioGroups = $('.attribute-select__group');
		const $allSelects = $customiser.find('select');

		if (!$customiser || !$radioGroups || !$allSelects) {
			return;
		}

		cff.selects = Array.from($allSelects);
		cff.radios = Array.from($radioGroups);

		cff.radios.forEach((group) => {
			const $ui = $(group);
			const $id = $ui.attr('data-select');
			const $select = $customiser.find(`#${$id}`)

			if(!$select) {
				return;
			}

			const $defaultRadio = $ui.find(':checked');

			$select.val( $defaultRadio.val()).trigger('change')

			$ui.find('.attribute-select__attribute-radio').each((i, radio) => {
				$(radio).on('click', function() {
					$select.val(this.value).trigger('change')
				})
			})

			$allSelects.on('change', cff.toggleRadios);
		})
	}

	cff.getVariationInfo = () => {
		const variation_id = document.querySelector('.variation_id');

		if(!variation_id)
		{
			return;
		}

	}

	cff.initNotificationLinks = function() {
		const links = document.querySelectorAll('.notification-button');

		if(!links.length)
		{
			return;
		}

		links.forEach((link) => {
			link.addEventListener('click', cff.createProductLink)
		})
	}

	cff.initBookingLinks = function() {
		// delegate handling to createProductLink()
		document.body.addEventListener('click', cff.createProductLink);
	}

	cff.decrementQty = function (e) {
		e.stopPropagation();
		e.preventDefault();

		let qty = Number(cff.realQtyPicker.value);

		qty -= step;

		cff.fakeQtyPicker.value = qty <= 0 ? 0 : qty;
		cff.realQtyPicker.value = qty <= 0 ? 0 : qty;
	}

	cff.incrementQty = function (e) {
		e.stopPropagation();
		e.preventDefault();

		let qty = Number(cff.realQtyPicker.value);
		qty += step;

		cff.realQtyPicker.value = qty;
		cff.fakeQtyPicker.value = qty;
	}

	cff.manualUpdateQty = function (e) {
		let input = e.target;
		let value = Number(input.value);

		e.target.value = value <= 1 ? 1 : value;
		cff.realQtyPicker.value = value <= 0 ? 1 : value;
	}

	cff.initCustomQtyUI = function() {
		const decrementButton = document.querySelector('.customiser .qty-picker__decrement');
		const incrementButton = document.querySelector('.customiser .qty-picker__increment');
		const fakeQtyInput = document.querySelector('.customiser input.qty-picker__number');
		const realQtyInput = document.querySelector('.customiser .quantity .qty');

		if(!decrementButton || !incrementButton || !fakeQtyInput || !realQtyInput)
		{
			return;
		}

		if(realQtyInput) {
			cff.realQtyPicker = realQtyInput;
		}

		if(!decrementButton || !incrementButton || !fakeQtyInput) {
			return;
		}

		cff.fakeQtyPicker = fakeQtyInput;

		//Decrease qty
		decrementButton.addEventListener('click', cff.decrementQty);

		//Manage manual entry change
		fakeQtyInput.addEventListener('change', cff.manualUpdateQty);

		//Increase qty
		incrementButton.addEventListener('click', cff.incrementQty);
	}

	cff.initQuantityPickers = function () {
		const pickers = document.querySelectorAll('.qty-picker');
		if (!pickers.length) return;

		function operateFloatsWithoutJunk(a, b, opFunc) {
			// convert numbers to integers for accurate fixed-point arithmetic, then convert back to floats
			const maxDecimals = 4;
			const factor = Math.pow(10, maxDecimals);
			const intA = Math.floor(a * factor);
			const intB = Math.floor(b * factor);

			return opFunc(intA, intB) / factor;
		}

		function add(a, b) {
			return a + b;
		}

		function subtract(a, b) {
			return a - b;
		}

		Array.from(pickers).forEach(picker => {
			const adder = picker.querySelector('.qty-picker__increment');
			const subtractor = picker.querySelector('.qty-picker__decrement');
			const display = picker.querySelector('.qty-picker__value');
			const input = picker.querySelector('input');

			// set a step if not set
			if (Number.isNaN(input.step)) {
				input.step = '1';
			}


			adder.addEventListener('click', () => {
				const currValue = Number(input.value);
				const step = Number(input.step);
				const newVal = operateFloatsWithoutJunk(currValue, step, add);
				if (input.max && newVal > Number(input.max)) {
					return;
				}
				input.value = newVal;
				input.dispatchEvent(new Event('change')); // trigger change event so other scripts can listen for it
				display.innerHTML = newVal;
			});

			subtractor.addEventListener('click', () => {
				const currValue = Number(input.value);
				const step = Number(input.step);
				const newVal = operateFloatsWithoutJunk(currValue, step, subtract);
				if (input.min && newVal < Number(input.min)) {
					return;
				}
				input.value = newVal;
				input.dispatchEvent(new Event('change')); // trigger change event so other scripts can listen for it
				display.innerHTML = newVal;
			});
		});
	}

	cff.init = function() {
		cff.initCustomUI();
		// cff.initCustomQtyUI();
		cff.initNotificationLinks();
		cff.initBookingLinks();
		cff.initQuantityPickers();
	}

	return cff;
})();

export default customFormFields;



// WEBPACK FOOTER //
// ./scripts/modules/wc-custom-form-fields.js